import React from 'react';

import ScrollView from 'devextreme-react/scroll-view';

import './singleCard.sass';

type ISingleCard = {
  title: String;
  description?: string;
  children?: React.ReactNode;
};

const SigleCard: React.FC<ISingleCard> = ({ title = '', description = '', children }) => (
  <ScrollView height={'100%'} width={'100%'} className={'with-footer single-card'}>
    <div className={'dx-card content'}>
      <div className={'header'}>
        <div className={'title'}>{title}</div>
        <div className={'description'}>{description}</div>
      </div>
      {children}
    </div>
  </ScrollView>
);

export default SigleCard;
